module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kg-La.025238f3.png";